/**
*
* WorkInProgress
*
*/

import WorkInProgress from './WorkInProgress.jsx'
import './WorkInProgress.less'

export default WorkInProgress